/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  MigrateRemoteSessionIssuerRequestBody,
  MigrateRemoteSessionIssuerRequestBody$Outbound,
  MigrateRemoteSessionIssuerRequestBody$outboundSchema,
} from "../components/migrateremotesessionissuerrequestbody.js";

export type MigrateToGlobalRemoteSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type MigrateToGlobalRemoteSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  migrateRemoteSessionIssuerRequestBody: MigrateRemoteSessionIssuerRequestBody;
};

/** @internal */
export type MigrateToGlobalRemoteSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const MigrateToGlobalRemoteSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    MigrateToGlobalRemoteSessionIssuerSecurity$Outbound,
    MigrateToGlobalRemoteSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function migrateToGlobalRemoteSessionIssuerSecurityToJSON(
  migrateToGlobalRemoteSessionIssuerSecurity:
    MigrateToGlobalRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    MigrateToGlobalRemoteSessionIssuerSecurity$outboundSchema.parse(
      migrateToGlobalRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type MigrateToGlobalRemoteSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  MigrateRemoteSessionIssuerRequestBody:
    MigrateRemoteSessionIssuerRequestBody$Outbound;
};

/** @internal */
export const MigrateToGlobalRemoteSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    MigrateToGlobalRemoteSessionIssuerRequest$Outbound,
    MigrateToGlobalRemoteSessionIssuerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      migrateRemoteSessionIssuerRequestBody:
        MigrateRemoteSessionIssuerRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        migrateRemoteSessionIssuerRequestBody:
          "MigrateRemoteSessionIssuerRequestBody",
      });
    }),
  );

export function migrateToGlobalRemoteSessionIssuerRequestToJSON(
  migrateToGlobalRemoteSessionIssuerRequest:
    MigrateToGlobalRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    MigrateToGlobalRemoteSessionIssuerRequest$outboundSchema.parse(
      migrateToGlobalRemoteSessionIssuerRequest,
    ),
  );
}
